"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/breadcrumb.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var className = _ref.className,
      isLastItem = _ref.isLastItem,
      url = _ref.url,
      text = _ref.text,
      props = _objectWithoutProperties(_ref, ["className", "isLastItem", "url", "text"]);

  var isClickable = url && !isLastItem;

  var classes = _defineProperty({
    'vn-breadcrumb__item': true
  }, className, className !== undefined);

  return _react.default.createElement("li", {
    className: (0, _classnames.default)(classes)
  }, isClickable && _react.default.createElement("a", _extends({
    "aria-label": text,
    className: "vn-breadcrumb__link",
    href: url
  }, props), text), !isClickable && text);
};

BreadcrumbItem.propTypes = {
  className: _propTypes.default.string,
  isLastItem: _propTypes.default.bool,
  text: _propTypes.default.string.isRequired,
  url: _propTypes.default.string
};
BreadcrumbItem.defaultProps = {
  className: undefined,
  isLastItem: false,
  url: undefined
};
BreadcrumbItem.displayName = 'BreadcrumbItem';

var Breadcrumb = function Breadcrumb(_ref2) {
  var className = _ref2.className,
      crumbs = _ref2.crumbs,
      props = _objectWithoutProperties(_ref2, ["className", "crumbs"]);

  var items = crumbs.map(function (crumb, index) {
    return _react.default.createElement(BreadcrumbItem, _extends({
      key: crumb.key || crumb.url || crumb.text
    }, crumb, {
      isLastItem: index === crumbs.length - 1
    }));
  });

  if (crumbs.length > 2) {
    items.unshift(_react.default.createElement(BreadcrumbItem, {
      className: "vn-breadcrumb__item--ellipsis",
      key: "...",
      text: "..."
    }));
  }

  var classes = _defineProperty({
    'vn-breadcrumb': true
  }, className, className !== undefined);

  return _react.default.createElement("ul", _extends({}, props, {
    className: (0, _classnames.default)(classes)
  }), items);
};

Breadcrumb.propTypes = {
  className: _propTypes.default.string,
  crumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    text: _propTypes.default.string.isRequired,
    url: _propTypes.default.string
  })).isRequired
};
Breadcrumb.defaultProps = {
  className: undefined
};
Breadcrumb.displayName = 'Breadcrumb';
var _default = Breadcrumb;
exports.default = _default;